export const BRIDGE_EXPERIMENT_NAME = "web23_ads_funnel_v1";
export const BRIDGE_QUIZ_URL = "https://quiz.builtwithscience.com/";
export const BRIDGE_CONTROL_URL = "https://builtwithscience.com/";
export const BRIDGE_CONTROL_REDIRECT_PARAM = "bws_quiz_redirect";
export const BRIDGE_CONTROL_REDIRECT_VALUE = "bridge_control";

export function buildBridgeControlRedirectValue(bridgeName?: string | null) {
  return bridgeName ? `${bridgeName}_bridge_control` : BRIDGE_CONTROL_REDIRECT_VALUE;
}

export function buildBridgeControlRedirectUrl(search: string, baseUrl: string = BRIDGE_CONTROL_URL) {
  const bridgeName = new URLSearchParams(search).get("utm_angle");
  let redirectUrl: URL;
  try {
    redirectUrl = new URL(baseUrl || BRIDGE_CONTROL_URL);
  } catch {
    redirectUrl = new URL(BRIDGE_CONTROL_URL);
  }
  // Carry the incoming params (minus utm_angle) onto the base URL, preserving any
  // query the base URL already had, then tag the control redirect.
  const incoming = new URLSearchParams(search);
  incoming.delete("utm_angle");
  incoming.forEach((val, key) => redirectUrl.searchParams.set(key, val));
  redirectUrl.searchParams.set(
    BRIDGE_CONTROL_REDIRECT_PARAM,
    buildBridgeControlRedirectValue(bridgeName)
  );
  return redirectUrl.toString();
}

export function buildBridgeControlRedirectUrlFromQuizUrl(quizUrl: string, baseUrl?: string) {
  return buildBridgeControlRedirectUrl(new URL(quizUrl).search, baseUrl);
}
